import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'
import { creditNumericValue } from '../credit/creditNumericValue'
import { creditRequestObject } from '../creditRequest/creditRequestObject'
import { citizenObject } from '~/packages/general/citizen/citizenObject'
import { residenceObject } from '~/packages/general/residence/residenceObject'

export const creditEconomicMovementObject = z.object({
  id: z.string().uuid(),
  creditRequestId: creditRequestObject.shape.id.nullish(),
  citizenId: citizenObject.shape.id,
  residenceId: residenceObject.shape.id,
  saleInvoiceNumber: z.string(),
  saleInvoiceDate: dateOrIsoString(),
  totalValue: creditNumericValue,
  sourceFilter: z.string().nullish(),
  clientId: z.number().int(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export const creditEconomicMovementCreateInputObject = creditEconomicMovementObject
  .pick({
    id: true,
    creditRequestId: true,
    citizenId: true,
    residenceId: true,
    saleInvoiceNumber: true,
    saleInvoiceDate: true,
    totalValue: true,
    clientId: true,
  })
  .extend({
    id: creditEconomicMovementObject.shape.id.nullish(),
    clientId: creditEconomicMovementObject.shape.clientId.nullish(),
  })

export const creditEconomicMovementUpdateInputObject = creditEconomicMovementObject
  .pick({
    id: true,
    creditRequestId: true,
    citizenId: true,
    residenceId: true,
    saleInvoiceNumber: true,
    saleInvoiceDate: true,
    totalValue: true,
  })
  .partial()
  .required({ id: true })

export type CreditEconomicMovementType = z.infer<typeof creditEconomicMovementObject>

export const propertyMap = {
  id: sql`credit_economic_movement.id`,
  creditRequestId: sql`credit_economic_movement.credit_request_id`,
  citizenId: sql`credit_economic_movement.citizen_id`,
  residenceId: sql`credit_economic_movement.residence_id`,
  saleInvoiceNumber: sql`credit_economic_movement.sale_invoice_number`,
  saleInvoiceDate: sql`credit_economic_movement.sale_invoice_date`,
  totalValue: sql`credit_economic_movement.total_value`,
  sourceFilter: sql`credit_economic_movement.source_filter`,
  clientId: sql`credit_economic_movement.client_id`,
  createdAt: sql`credit_economic_movement.created_at`,
  updatedAt: sql`credit_economic_movement.updated_at`,
  deletedAt: sql`credit_economic_movement.deleted_at`,
}

export default creditEconomicMovementObject
